const BASE = process.env.REACT_APP_BACKEND_URL;
export const KEY_STORE = "aliasOpKey";

export const getKey = () => sessionStorage.getItem(KEY_STORE) || "";
export const setKey = (k) => sessionStorage.setItem(KEY_STORE, k);
export const clearKey = () => sessionStorage.removeItem(KEY_STORE);

async function req(path, opts = {}) {
  const res = await fetch(`${BASE}/api/operator${path}`, {
    ...opts,
    headers: { "Content-Type": "application/json", "X-Operator-Key": getKey(), ...(opts.headers || {}) },
  });
  let data = null;
  try { data = await res.json(); } catch (_) {}
  if (!res.ok) {
    const detail = data && data.detail;
    const err = new Error((detail && detail.message) || detail || `Request failed (${res.status})`);
    err.status = res.status;
    err.nextAction = detail && detail.nextAction;
    throw err;
  }
  return data;
}

export const api = {
  listJobs: () => req("/jobs"),
  createJob: (label, clientEmail) => req("/jobs", { method: "POST", body: JSON.stringify({ label: label || null, clientEmail: clientEmail || null }) }),
  jobDetail: (id) => req(`/jobs/${id}`),
  intake: (id) => req(`/jobs/${id}/intake`),
  sendIntakeEmail: (id, confirm) => req(`/jobs/${id}/send-intake-email${confirm ? "?confirmHistorical=true" : ""}`, { method: "POST" }),
  reissueIntake: (id) => req(`/jobs/${id}/reissue-intake-link`, { method: "POST" }),
  generate: (id) => req(`/jobs/${id}/generate`, { method: "POST" }),
  approve: (id) => req(`/jobs/${id}/approve`, { method: "POST" }),
  issueReview: (id, confirm) => req(`/jobs/${id}/issue-review${confirm ? "?confirmHistorical=true" : ""}`, { method: "POST" }),
  changeRequest: (id, version, items) => req(`/jobs/${id}/change-request`, { method: "POST", body: JSON.stringify({ version, items }) }),
  requestDecisions: (id, decisions) => req(`/jobs/${id}/request-decisions`, { method: "POST", body: JSON.stringify({ decisions }) }),
  previewSession: () => req("/preview-session", { method: "POST", credentials: "include" }),
  revokeReview: (id) => req(`/jobs/${id}/revoke-review`, { method: "POST" }),
  storageStatus: () => req("/storage-status"),
  revise: (id) => req(`/jobs/${id}/revise`, { method: "POST" }),
  publishStatus: (id) => req(`/jobs/${id}/publish`),
  publish: (id, body) => req(`/jobs/${id}/publish`, { method: "POST", body: JSON.stringify(body) }),
  verifyLive: (id) => req(`/jobs/${id}/verify-live`, { method: "POST" }),
  reconcilePublish: (id) => req(`/jobs/${id}/publish/reconcile`, { method: "POST" }),
  visualUpdate: (id, version, reason, phone, footerTagline, image) => req(`/jobs/${id}/visual-update`, { method: "POST", body: JSON.stringify({ version, reason, phone, footerTagline, image }) }),
  imageChoices: (id) => req(`/jobs/${id}/image-choices`),
};

// Intake token is shown once by the server; keep the copy-able link in the browser for re-copy.
export const intakeLinkStore = {
  get: (id) => localStorage.getItem(`intake:${id}`) || "",
  set: (id, link) => localStorage.setItem(`intake:${id}`, link),
};

export const absUrl = (p) => (p ? `${BASE}${p}` : null);

export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (_) {
    return false;
  }
}
